
class SelectorVariants extends HTMLElement {
    constructor() {
        super();
        this.form = this.closest('form')
        this.addEventListener('change', this.onVariantChange);
    }
    onVariantChange(event) {
        this.currentVariant = event.target.value
        this.updateMasterId()
        this.updateURL();
        this.renderProductInfo();
    }
    updateMasterId() {
        this.form.querySelector('.add-to-cart').setAttribute('data-variant-id', this.currentVariant)
    }
    updateURL(){
        const url = new URL(window.location);
        url.searchParams.set('variant', this.currentVariant);
        window.history.pushState(null, '', url.toString());
    }

    async renderProductInfo(){
        try{
            const response = await (await fetch(window.location.href + '&section_id=product-template')).text()
            const responseMarkup = new DOMParser().parseFromString(response, 'text/html')
            document.querySelector('[data-price-container]').innerHTML = responseMarkup.querySelector('[data-price-container]').innerHTML

            document.dispatchEvent(new CustomEvent('changed_variant', {
                    bubbles: true,
                    detail: {
                        section: this.form
                    }
                }));

        }catch (error) {
            console.error(error)
        }
    }

}
customElements.define('selector-variants', SelectorVariants);

/* NDK 2026-08: la clase DiscountCoupon de la era Dcart fue ELIMINADA de este archivo.
   Su getDiscount() llamaba a /apps/proxy (backend de la app Dcart, no instalada en IT)
   en cada page load con cookie de descuento — una petición muerta por carga.
   El dueño único de los descuentos en IT es assets/ndk-discount-engine.js, que ya
   sobreescribía window.discountCoupon en runtime (aquí solo quedaba una clase zombie).
   Pintado de precios PDP con cupón: ndk-discount-engine.js → applyPercentageToCards(). */
